import report from "../utils/report";
var Spm = {
  reportor: null,
  /**
   * 上报pv
   * @param page 页面标识或者'<站点id>.<页面id>'
   * @param extraParams  扩展参数
   * @param autoPv 自动上报pv数据，默认true
   */
  loadSpm: function loadSpm(page) {
    var extraParams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var autoPv = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    try {
      // loadSpm 方法的page扩展了用法，
      // 上报国际侧暂无计划应用新特性，
      // 只在双写测试下在alipaySpm下使用
      // 具体参考 types.ts 中的 type LoadSpm
      if (typeof page === 'string') {
        var _Spm$reportor;
        (_Spm$reportor = Spm.reportor) === null || _Spm$reportor === void 0 ? void 0 : _Spm$reportor.loadSpm(page, extraParams, autoPv);
      }
    } catch (error) {
      report({
        logType: 'error',
        title: 'tracker-error',
        msg: error
      });
    }
  },
  /**
   * 点击上报
   * @param code 点击标识或者 '<站点id>.<页面id>.<区块id>.<点击id>'
   * @param extra 扩展参数
   */
  spmClick: function spmClick(code) {
    var extra = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    try {
      var _Spm$reportor2;
      (_Spm$reportor2 = Spm.reportor) === null || _Spm$reportor2 === void 0 ? void 0 : _Spm$reportor2.spmClick(code, extra);
    } catch (error) {
      report({
        logType: 'error',
        title: 'tracker-error',
        msg: error
      });
    }
  },
  /**
   * 曝光上报
   * @param code 曝光标识或者 '<站点id>.<页面id>.<区块id>'
   * @param extra 扩展参数
   */
  spmExpo: function spmExpo(code) {
    var extra = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    try {
      var _Spm$reportor3;
      (_Spm$reportor3 = Spm.reportor) === null || _Spm$reportor3 === void 0 ? void 0 : _Spm$reportor3.spmExpo(code, extra);
    } catch (error) {
      report({
        logType: 'error',
        title: 'tracker-error',
        msg: error
      });
    }
  },
  set: function set() {
    var opt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    try {
      Object.assign(Spm, opt);
    } catch (error) {
      report({
        logType: 'error',
        title: 'tracker-error',
        msg: error
      });
    }
  },
  pageMonitor: function pageMonitor( /* eslint-disable @typescript-eslint/no-unused-vars */
  _conf, _extraParams, _autoPv
  /* eslint-enable @typescript-eslint/no-unused-vars */) {
    throw new Error('Function not implemented.');
  }
};
export default Spm;